import { jsx as w, jsxs as U } from "react/jsx-runtime";
import { useState as I, useEffect as J, useRef as $, useId as W, useMemo as q, useCallback as D } from "react";
import { u as Z, a as ee, o as te, f as ne, s as oe, b as ae, c as re, d as se, e as ie, F as ce } from "./floating-ui.react-87bo4V3_.js";
import { w as le } from "./windowControlsClearance-BonpJzP6.js";
const c = Object.freeze({
  maxAnchorContextBytes: 512,
  maxAnchorExactBytes: 4 * 1024,
  maxBodyBytes: 32 * 1024,
  maxEntityKeyBytes: 512,
  maxMentions: 50,
  maxMutationIdCharacters: 200,
  maxPageSize: 100
});
class f extends Error {
  code;
  constructor(t, o) {
    super(o), this.name = "CollabCommentControllerError", this.code = t;
  }
}
const Q = new TextEncoder();
function b(e) {
  return Q.encode(e).byteLength;
}
function Ce(e, t) {
  const o = Q.encode(e);
  return o.byteLength <= t ? e : new TextDecoder().decode(o.slice(0, t));
}
function P(e) {
  return e.replace(/\r\n?/g, `
`).replace(/\u00a0/g, " ");
}
function j(e) {
  const t = e.trim();
  if (!t)
    throw new f(
      "BODY_TOO_LARGE",
      "Comment body must not be empty."
    );
  if (b(t) > c.maxBodyBytes)
    throw new f(
      "BODY_TOO_LARGE",
      `Comment body exceeds ${c.maxBodyBytes} bytes.`
    );
  return t;
}
function ge(e, t) {
  if (!t)
    throw new f(
      "DOCUMENT_NOT_HYDRATED",
      "The collaborative document has not finished hydrating."
    );
  if (!e.comment)
    throw new f(
      "COMMENT_FORBIDDEN",
      "You do not have permission to comment on this document."
    );
}
function Me(e) {
  const t = e.trim();
  if (!t || t.length > c.maxMutationIdCharacters)
    throw new f(
      "MUTATION_CONFLICT",
      `clientMutationId must be between 1 and ${c.maxMutationIdCharacters} characters.`
    );
  return t;
}
function Ne(e, t) {
  const o = [...new Set(e ?? [])];
  if (o.length > c.maxMentions)
    throw new f(
      "MENTION_FORBIDDEN",
      `A comment may mention at most ${c.maxMentions} users.`
    );
  const a = new Set(t.map((s) => s.userId));
  if (o.some((s) => !a.has(s)))
    throw new f(
      "MENTION_FORBIDDEN",
      "One or more mentioned users are not available in this organization."
    );
  return o;
}
function Ee(e) {
  return {
    limit: Math.max(
      1,
      Math.min(
        c.maxPageSize,
        Math.floor(e.limit ?? c.maxPageSize)
      )
    ),
    cursor: Math.max(0, Number.parseInt(e.cursor ?? "0", 10) || 0)
  };
}
function Oe(e) {
  const t = P(e.exact), o = P(e.prefix ?? ""), a = P(e.suffix ?? "");
  if (!t || b(t) > c.maxAnchorExactBytes)
    throw new f(
      "ANCHOR_NOT_FOUND",
      `Anchor exact text must be between 1 and ${c.maxAnchorExactBytes} bytes.`
    );
  if (b(o) > c.maxAnchorContextBytes || b(a) > c.maxAnchorContextBytes)
    throw new f(
      "ANCHOR_NOT_FOUND",
      `Anchor prefix and suffix must not exceed ${c.maxAnchorContextBytes} bytes each.`
    );
  return { exact: t, prefix: o, suffix: a };
}
function Y(e, t) {
  return `${e}-option-${t}`;
}
function me({
  referenceElement: e,
  candidates: t,
  activeIndex: o,
  open: a,
  listboxId: s,
  onSelect: u,
  onActiveIndexChange: A,
  onDismiss: h
}) {
  const m = a && t.length > 0 && e !== null, { refs: T, floatingStyles: B, context: M } = Z({
    open: m,
    onOpenChange: (i) => {
      i || h();
    },
    elements: { reference: e ?? void 0 },
    placement: "bottom-start",
    middleware: [
      te(4),
      ne({ padding: 8 }),
      oe({ padding: 8 }),
      le(),
      ae({
        padding: 8,
        apply: ({ availableHeight: i, elements: l }) => {
          l.floating.style.maxHeight = `${Math.max(96, Math.min(240, i))}px`;
        }
      })
    ],
    whileElementsMounted: ee
  }), d = re(M, { escapeKey: !1 }), N = se(M, { role: "listbox" }), { getFloatingProps: p } = ie([d, N]);
  return m ? /* @__PURE__ */ w(ce, { children: /* @__PURE__ */ w(
    "div",
    {
      ref: T.setFloating,
      className: "nim-comment-mention-picker",
      "data-testid": "comment-mention-picker",
      id: s,
      style: B,
      ...p(),
      children: t.map((i, l) => /* @__PURE__ */ U(
        "div",
        {
          id: Y(s, l),
          role: "option",
          "aria-selected": l === o,
          className: l === o ? "nim-comment-mention-option active" : "nim-comment-mention-option",
          onMouseDown: (C) => C.preventDefault(),
          onMouseEnter: () => A(l),
          onClick: () => u(i),
          children: [
            /* @__PURE__ */ w("span", { className: "nim-comment-mention-name", children: i.name }),
            i.email && i.email !== i.name && /* @__PURE__ */ w("span", { className: "nim-comment-mention-email", children: i.email })
          ]
        },
        i.userId
      ))
    }
  ) }) : null;
}
function ue(e, t) {
  const [o, a] = I(() => e());
  return J(() => {
    t !== null && a((s) => {
      const u = e();
      return s.length === u.length && s.every((h, m) => h.userId === u[m].userId && h.name === u[m].name && h.email === u[m].email) ? s : u;
    });
  }, [t, e]), o;
}
function de(e, t) {
  const o = (t ?? "").trim().toLowerCase();
  return o ? e.filter((a) => a.name.toLowerCase().includes(o) || (a.email ?? "").toLowerCase().includes(o)) : e;
}
function fe(e, t) {
  const o = new Set(t.map((a) => a.userId));
  return e.filter((a) => o.has(a));
}
const he = 10;
function H(e, t) {
  const o = e.slice(0, t), a = /(?:^|[\s(])@([^\s@]{0,75})$/.exec(o);
  return a ? { query: a[1], start: t - a[1].length - 1 } : null;
}
function De({
  getMembers: e,
  onSubmit: t,
  onCancel: o,
  submitLabel: a,
  placeholder: s,
  autoFocus: u = !1,
  label: A,
  className: h
}) {
  const m = $(null), [T, B] = I(
    null
  ), M = $(/* @__PURE__ */ new Map()), [d, N] = I(""), [p, i] = I(null), [l, C] = I(0), k = W(), L = ue(e, p), g = q(
    () => p === null ? [] : de(L, p).slice(
      0,
      he
    ),
    [L, p]
  ), E = p !== null && g.length > 0, V = q(() => {
    try {
      return j(d), !0;
    } catch {
      return !1;
    }
  }, [d]), _ = $(null), x = D(() => {
    _.current = null, i(null), C(0);
  }, []), v = D((n) => {
    const r = H(n.value, n.selectionStart ?? 0), y = r ? r.query : null;
    _.current !== y && (_.current = y, i(y), C(0));
  }, []), R = D(
    (n) => {
      const r = m.current;
      if (!r) return;
      const y = r.selectionStart ?? r.value.length, O = H(r.value, y);
      if (!O) return;
      const z = `@${n.name} `, X = r.value.slice(0, O.start) + z + r.value.slice(y);
      M.current.set(n.name, n.userId), N(X), x();
      const K = O.start + z.length;
      requestAnimationFrame(() => {
        const F = m.current;
        F && (F.focus(), F.setSelectionRange(K, K));
      });
    },
    [x]
  ), S = D(() => {
    if (!d.trim()) {
      o();
      return;
    }
    let n;
    try {
      n = j(d);
    } catch {
      return;
    }
    const r = [];
    for (const [y, O] of M.current)
      d.includes("@" + y) && r.push(O);
    t(
      n,
      fe([...new Set(r)], e())
    ), N(""), M.current.clear(), x();
  }, [d, t, o, e, x]), G = D(
    (n) => {
      if (E) {
        if (n.key === "ArrowDown") {
          n.preventDefault(), C((r) => (r + 1) % g.length);
          return;
        }
        if (n.key === "ArrowUp") {
          n.preventDefault(), C(
            (r) => (r - 1 + g.length) % g.length
          );
          return;
        }
        if (n.key === "Enter" || n.key === "Tab") {
          n.preventDefault(), R(g[l]);
          return;
        }
        if (n.key === "Escape") {
          n.preventDefault(), n.stopPropagation(), x();
          return;
        }
      }
      if (n.key === "Enter" && (n.metaKey || n.ctrlKey)) {
        n.preventDefault(), S();
        return;
      }
      n.key === "Escape" && (n.preventDefault(), n.stopPropagation(), o());
    },
    [
      E,
      g,
      l,
      R,
      x,
      S,
      o
    ]
  );
  return /* @__PURE__ */ U(
    "div",
    {
      className: h ? `nim-comment-composer ${h}` : "nim-comment-composer",
      "data-testid": "comment-composer",
      children: [
        /* @__PURE__ */ w(
          "textarea",
          {
            ref: (n) => {
              m.current = n, B(n);
            },
            className: "nim-comment-composer-input",
            "data-testid": "comment-composer-input",
            "aria-label": A ?? s,
            "aria-placeholder": s,
            placeholder: s,
            "aria-autocomplete": "list",
            "aria-expanded": E,
            "aria-controls": E ? k : void 0,
            "aria-activedescendant": E ? Y(k, l) : void 0,
            autoFocus: u,
            rows: 2,
            value: d,
            onChange: (n) => {
              N(n.target.value), v(n.target);
            },
            onKeyUp: (n) => v(n.currentTarget),
            onClick: (n) => v(n.currentTarget),
            onBlur: x,
            onKeyDown: G
          }
        ),
        /* @__PURE__ */ w(
          me,
          {
            referenceElement: T,
            candidates: g,
            activeIndex: l,
            open: p !== null,
            listboxId: k,
            onSelect: R,
            onActiveIndexChange: C,
            onDismiss: x
          }
        ),
        /* @__PURE__ */ U("div", { className: "nim-comment-composer-actions", children: [
          /* @__PURE__ */ w(
            "button",
            {
              type: "button",
              className: "nim-comment-btn nim-comment-btn-cancel",
              onClick: o,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ w(
            "button",
            {
              type: "button",
              className: "nim-comment-btn nim-comment-btn-submit",
              disabled: !V,
              onClick: S,
              children: a
            }
          )
        ] })
      ]
    }
  );
}
export {
  De as C,
  me as a,
  fe as b,
  b as c,
  c as d,
  ge as e,
  de as f,
  f as g,
  Me as h,
  Ne as i,
  Ee as j,
  Oe as k,
  Y as m,
  P as n,
  H as r,
  Ce as t,
  ue as u,
  j as v
};
//# sourceMappingURL=CommentComposer-CmMmKWAF.js.map
